export const getWorksheetsUrl = (workspaceId: string, agentId: string) =>
  `/business/workspaces/${workspaceId}/agents/${agentId}/worksheets`;

export const getWorksheetUrl = (workspaceId: string, agentId: string, worksheetId: string) =>
  `/business/workspaces/${workspaceId}/agents/${agentId}/worksheets/${worksheetId}`;

export const getDeleteColumnUrl = (workspaceId: string, agentId: string, worksheetId: string, columnId: string) =>
  `/business/workspaces/${workspaceId}/agents/${agentId}/worksheets/${worksheetId}/columns/${columnId}`;

export const getDeleteRowUrl = (workspaceId: string, agentId: string, worksheetId: string) =>
  `/business/workspaces/${workspaceId}/agents/${agentId}/worksheets/${worksheetId}/rows`;

export const getAddColumnUrl = (workspaceId: string, agentId: string, worksheetId: string) =>
  `/business/workspaces/${workspaceId}/agents/${agentId}/worksheets/${worksheetId}/columns`;

export const getRowsUrl = (workspaceId: string, agentId: string, worksheetId: string) =>
  `/business/workspaces/${workspaceId}/agents/${agentId}/worksheets/${worksheetId}/rows`;

export const getAddCRowUrl = (workspaceId: string, agentId: string, worksheetId: string) =>
  `/business/workspaces/${workspaceId}/agents/${agentId}/worksheets/${worksheetId}/rows`;

export const UpdateCellUrl = (workspaceId: string, agentId: string, worksheetId: string, columnId: any, rowId: any) =>
  `/business/workspaces/${workspaceId}/agents/${agentId}/worksheets/${worksheetId}/cells?row_id=${rowId}&column_id=${columnId}`;

export const UpdateColumnUrl = (workspaceId: string, agentId: string, worksheetId: string, columnId: any) =>
  `/business/workspaces/${workspaceId}/agents/${agentId}/worksheets/${worksheetId}/columns/${columnId}`;

export const UpdateRowUrl = (workspaceId: string, agentId: string, worksheetId: string, rowId: string) =>
  `/business/workspaces/${workspaceId}/agents/${agentId}/worksheets/${worksheetId}/rows/${rowId}`;

export const workflowExecuteUrl = (workspaceId: string, agentId: string, worksheetId: string) =>
  `/business/workspaces/${workspaceId}/agents/${agentId}/worksheets/${worksheetId}/workflows/execute?`;

export const importCsvUrl = (workspaceId: string, agentId: string, worksheetId: string) =>
  `/business/workspaces/${workspaceId}/agents/${agentId}/worksheets/${worksheetId}/upload_file`;

export const appendCsvUrl = (workspaceId: string, agentId: string, worksheetId: string) =>
  `/business/workspaces/${workspaceId}/agents/${agentId}/worksheets/${worksheetId}/append_from_csv`;

export const getWorkflowUrl = (workspaceId: string) => `/business/workspaces/${workspaceId}/workflows`;
